import { Component, inject } from '@angular/core';
import { IdleSessionModalComponent } from 'src/app/core/auth/shared/components/modals/idle-session-modal/idle-session-modal.component';

import { HistoryService } from './core/layout/services/history.service';
import { PageLayoutComponent } from './core/layout/shared/components/page-layout/page-layout.component';
import { StartupErrorComponent } from './core/layout/shared/components/startup-error/startup-error.component';
import { HealthStatusComponent } from './shared/components/health-status/health-status.component';
import { EnumCatalogueService } from './shared/services/enum-catalogue/enum-catalogue.service';
import { NotificationsComponent } from './shared/ui/notifications/notifications.component';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	imports: [
		PageLayoutComponent,
		NotificationsComponent,
		HealthStatusComponent,
		IdleSessionModalComponent,
		StartupErrorComponent,
	],
})
export class AppComponent {
	readonly historyService = inject(HistoryService);

	/** The startup data failed to load: the startup error replaces the whole app. */
	protected readonly startupFailed = inject(EnumCatalogueService).loadFailed;
}
